
function isPlainObject(a) {
    return (!!a) && (a.constructor === Object);
}

export {
    isPlainObject
}
